"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.isequal")),
    _uiKit = require("@devsta/ui-kit"),
    _AddonsPayment = _interopRequireDefault(require("./AddonsPayment")),
    _ChangesModal = _interopRequireDefault(require("../../ChangesModal")),
    _utils = require("../utils");

require("../styles/_payments-invoice.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var OUTPUT_STATUS = {
  INTERNAL_REVIEW: "INTERNAL_REVIEW",
  PENDING_REVIEW: "PENDING_REVIEW",
  COST_REVIEW: "COST_REVIEW"
},
    PaymentsInvoice = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.setPurchaseOrderId = function (a) {
      var b = a.target.value;
      d.setState({
        purchaseOrderId: b
      });
    }, d.goToConfirmationModal = function () {
      d.setState({
        showConfirmationModal: !0,
        stayOpen: !1
      });
    }, d.handleSave = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b,
          c,
          e,
          f,
          g,
          h,
          i,
          j,
          k = arguments;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = 0 < k.length && void 0 !== k[0] ? k[0] : [], c = d.state, e = c.purchaseOrderId, f = c.totalCost, g = c.selectedTeamId, h = d.props, i = h.onConfirm, j = h.onCreditsUpdated, a.next = 5, i(_objectSpread({
                purchaseOrderId: e,
                clientRejectionReasons: b,
                hasCost: !!f
              }, g ? {
                teamId: g
              } : {}));

            case 5:
              j();

            case 6:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.modalSaveHandler = function () {
      var a = d.state,
          b = a.showConfirmationModal,
          c = a.stayOpen;
      return c ? d.goToConfirmationModal : b ? void 0 : d.handleSave;
    }, d.setCreditInfo = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j, k, l;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (b = d.props, c = b.getTeamCredits, e = b.getOrgCredits, c && e) {
                a.next = 3;
                break;
              }

              return a.abrupt("return");

            case 3:
              return a.next = 5, e();

            case 5:
              return f = a.sent, g = f.data, h = f.error, a.next = 10, c();

            case 10:
              if (i = a.sent, j = i.data, k = i.error, g && !h && j && !k) {
                a.next = 15;
                break;
              }

              return a.abrupt("return");

            case 15:
              l = 0 < j.getTeamMemberships.length ? j.getTeamMemberships.map(function (a) {
                var b = a.team;
                return b.teamId;
              }) : [], d.setState({
                orgCreditInfo: g.getOrganisation,
                teamCreditInfo: j.getTeamMemberships,
                selectedTeamId: l[0]
              });

            case 17:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.onSelectTeam = function (a) {
      d.setState({
        selectedTeamId: a.value
      });
    }, d.setTotalCost = function () {
      var a = d.props,
          b = a.videoOutputs,
          c = a.getAddonsCost,
          e = a.addonsSelector,
          f = a.excludeAdditionalOutputCost,
          g = b.reduce(function (a, b) {
        var d = b.isMaster,
            g = d || f ? b.versions[0][e] : _objectSpread({
          VIDEO_OUTPUT: {
            value: "ADDITIONAL_OUTPUT"
          }
        }, b.versions[0][e]),
            h = c(g, {
          numberValue: !0
        });
        return a + +h;
      }, 0),
          h = 0 === g;
      d.setState(function (a) {
        var b = a.stayOpen;
        return {
          totalCost: g,
          stayOpen: b && !h,
          showConfirmationModal: b && h
        };
      });
    }, d.state = {
      showConfirmationModal: !1,
      stayOpen: a.stayOpen,
      totalCost: -1,
      purchaseOrderId: "",
      orgCreditInfo: {},
      teamCreditInfo: [],
      selectedTeamId: ""
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this.props.showCreditInfo;
      this.setTotalCost(), a && this.setCreditInfo();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      var b = a.videoOutputs,
          c = this.props.videoOutputs;
      (0, _lodash["default"])(b, c) || this.setTotalCost();
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.visible,
          c = a.videoOutputs,
          d = a.videoName,
          e = a.addonsSelector,
          f = a.excludeAdditionalOutputCost,
          g = a.onClose,
          h = a.outputStatus,
          i = a.showCreditInfo,
          j = a.getCurrencySymbol,
          k = this.state,
          l = k.totalCost,
          m = k.showConfirmationModal,
          n = k.stayOpen,
          o = k.orgCreditInfo,
          p = k.teamCreditInfo,
          q = k.selectedTeamId;
      if (-1 === l) return null;
      var r = !!i && !(0, _utils.canSubmit)({
        orgCreditInfo: o,
        teamCreditInfo: p,
        selectedTeamId: q
      }),
          s = h === OUTPUT_STATUS.INTERNAL_REVIEW;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("payments-invoice-modal", {
          "output-changes-modal": m
        })
      }, m ? _react["default"].createElement(_ChangesModal["default"], (0, _extends2["default"])({
        visible: b,
        onClose: g,
        saveText: "Submit Changes",
        onSave: this.handleSave,
        stayOpenOnSave: n,
        columns: s,
        multiple: !0
      }, (0, _utils.getChangesModalConstants)(h))) : _react["default"].createElement(_uiKit.FormModal, {
        visible: b,
        onClose: g,
        saveText: "Confirm",
        onSave: this.modalSaveHandler(),
        stayOpenOnSave: n,
        saveDisabled: r,
        title: "Confirm Payment"
      }, _react["default"].createElement(_AddonsPayment["default"], {
        videoOutputs: c,
        addonsSelector: e,
        videoName: d,
        excludeAdditionalOutputCost: !!f,
        updatePurchaseOrderId: this.setPurchaseOrderId,
        totalCost: l,
        showCreditInfo: i || !1,
        orgCreditInfo: o,
        teamCreditInfo: p,
        getCurrencySymbol: j,
        isSaveDisabled: r,
        onSelectTeam: this.onSelectTeam
      })));
    }
  }]), b;
}(_react.Component);

exports["default"] = PaymentsInvoice;